// Per-NC-file send/upload lifecycle for sending a favorite version to a machine.
export const SEND_STATUS = {
  Uploading: 'Uploading',
  UploadingError: 'UploadingError',
  Sending: 'Sending',
  Sent: 'Sent',
  Error: 'Error',
  Finish: 'Finish',
} as const;
